import React, { useRef, useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Breadcrumb from "../../../components/common/BreadCrumb";
import { Close, Duplicate, LogoBlack } from "../../../assets/svg";
import CustomTable from "../../../components/customTable/CustomTable";
import {
  DefaultButton,
  DefaultPrimaryButton,
} from "../../../components/micro/input";
import ButtonLoader from "../../../components/loader/ButtonLoader";
import ConfirmationModel from "../../../components/common/ConfirmationModel";

const contractData = [
  {
    id: 1,
    title: "“Frequency” Recurring ",
    quantity: 10,
    unitPrice: "$100",
    price: "$100",
  },
  {
    id: 2,
    title: "cell",
    quantity: 10,
    unitPrice: "$100",
    price: "$100",
  },
  {
    id: 3,
    title: "cell",
    quantity: 10,
    unitPrice: "$100",
    price: "$100",
  },
  {
    id: 4,
    title: "cell",
    quantity: 10,
    unitPrice: "$100",
    price: "$100",
  },
  {
    id: 5,
    title: "cell",
    quantity: 10,
    unitPrice: "$100",
    price: "$100",
  },
];

const Contract = ({ onClose, type, modal }) => {
  const recurringContractRef = useRef();
  const termsConditionRef = useRef();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const ColumnHeaders = () => (
    <>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start w-1/6"
      >
        No.
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start w-5/6 "
      >
        Title
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start w-5/6 "
      >
        Quantity
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start w-5/6 "
      >
        Unit Price
      </th>
      <th
        scope="col"
        className="p-2 font-Proxima text-base font-normal py-4 px-4 text-mgrey text-start w-5/6 "
      >
        Price
      </th>
    </>
  );

  const DataRows = () => (
    <>
      {contractData.map((element, index) => (
        <tr
          key={index}
          className="font-Proxima text-[14px] shadow-sm text-mgrey "
        >
          <td className="px-5 py-3">{element.id}</td>
          <td className="px-5 py-3">{element.title}</td>
          <td className="px-5 py-3">{element.quantity}</td>
          <td className="px-5 py-3">{element.unitPrice}</td>
          <td className="px-5 py-3">{element.price}</td>
        </tr>
      ))}
    </>
  );

  const handleDownloadPDF = async () => {
    // Capture Recurring Contract section
    const recurringContractRef = document.getElementById("recurringContract");
    const recurringCanvas = await html2canvas(recurringContractRef, {
      scale: 2,
    });
    const recurringImgData = recurringCanvas.toDataURL("image/png");

    // Create PDF and add the first page (Recurring Contract)
    const pdf = new jsPDF("p", "mm", "a4");
    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight =
      (recurringCanvas.height * pdfWidth) / recurringCanvas.width;
    pdf.addImage(recurringImgData, "PNG", 0, 0, pdfWidth, pdfHeight);

    // Now, capture the Terms & Conditions section
    const termsConditionRef = document.getElementById("termsCondition");
    const termsCanvas = await html2canvas(termsConditionRef, { scale: 2 });
    const termsImgData = termsCanvas.toDataURL("image/png");

    // Check if the content overflows (you may need to adjust page height)
    const termsHeight = (termsCanvas.height * pdfWidth) / termsCanvas.width;

    // Add a new page for Terms & Conditions and add the image
    pdf.addPage();
    pdf.addImage(termsImgData, "PNG", 0, 0, pdfWidth, termsHeight);

    // Save the PDF
    pdf.save("contract_preview.pdf");
  };

  return (
    <>
      <div onClick={onClose}>
        {modal === "true" ? (
          ""
        ) : (
          <div>
            <h6 className="font-Montserrat font-medium text-xl mb-3">
              Recurring Contract
            </h6>
            <Breadcrumb
              breadCrumbParent={"Home"}
              breadCrumbActive={"Recurring Contract"}
              breadCrumbTitleKey={"/"}
              classes=""
            />
          </div>
        )}
        <div
          className={` rounded-lg max-w-5xl py-8 px-6 mx-auto relative h-2/3 overflow-auto`}
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <div className="flex justify-end mb-2">
            <button onClick={onClose}>
              <Close />
            </button>
          </div>
          <div className="flex justify-end mb-2">
            {type === "History" ? (
              <button className="flex text-themeBtn font-Proxima text-sm justify-center items-center">
                {" "}
                <Duplicate />
                DUPLICATE
              </button>
            ) : (
              ""
            )}
          </div>
          <div>
            <div
              className="w-full shadow-lg rounded-lg py-8 px-6"
              id="recurringContract"
              ref={recurringContractRef}
            >
              <div>
                <div className="flex justify-between">
                  <LogoBlack />
                  <div className="w-1/3">
                    <div>
                      <p className="font-Montserrat font-semibold text-xl text-mgrey">
                        FBK Group Pte Ltd
                      </p>
                      <p className="font-Proxima font-normal text-sm text-mgrey">
                        (UEN: 201402444D)
                      </p>
                    </div>
                    <div>
                      <div className="flex items-start">
                        <p className="font-Proxima font-bold text-sm text-black">
                          Address:
                        </p>
                        <p className="font-Proxima font-normal text-sm text-mgrey">
                          {" "}
                          3 Ubi Ave 3 #03-04Crocodile House (S) 540887
                        </p>
                      </div>
                      <div className="flex items-center gap-1">
                        <p className="font-Proxima font-semibold text-sm text-black">
                          Contact No:
                        </p>
                        <p className="font-Proxima font-normal text-sm text-mgrey">
                          6443 3824
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* report */}
                <div>
                  <h2 className="text-3xl font-Montserrat text-mgrey font-normal my-4">
                    Recurring Contract
                  </h2>
                  <p className="mb-2 font-Proxima text-base font-normal text-mgrey">
                    Report ID: #0001
                  </p>
                  <h6 className="text-xl font-Montserrat font-medium mb-4">
                    "Company Name"
                  </h6>
                  <div className="mb-4 ">
                    <div className="flex gap-3">
                      <div className="mb-4 text-sm font-normal font-Proxima text-mgrey">
                        <p>"Outlet Name"</p>
                        <p className="break-words w-36">
                          60 Paya Lebar Road #01-01 Paya Lebar Square Singapore
                          409052
                        </p>
                      </div>
                      <div className="text-sm font-normal font-Proxima text-mgrey">
                        <div className="flex">
                          <p className="w-20">Attention:</p>
                          <p>Mr. Adrian Toh</p>
                        </div>
                        <div className="flex">
                          <p className="w-20">Tel:</p>
                          <p>9333 6666</p>
                        </div>
                        <div className="flex">
                          <p className="w-20">Email:</p>
                          <p>theemail@rmail.com</p>
                        </div>
                        <div className="flex">
                          <p className="w-20">Date:</p>
                          <p>13/06/2023</p>
                        </div>
                      </div>
                    </div>

                    <div className="mb-4 text-sm font-normal font-Proxima text-mgrey">
                      <p>Contract ID: #0001</p>
                      <p>Start Date: 17/07/2023</p>
                      <p>End Date: 16/07/2024</p>
                    </div>
                  </div>
                </div>
                {/* table */}
                <div>
                  <div className="w-full bg-white shadow rounded-lg mt-5 ">
                    <CustomTable
                      columnHeaders={<ColumnHeaders />}
                      dataRows={<DataRows />}
                      data={contractData}
                      loading={false}
                    />
                  </div>
                  <div className="flex justify-end">
                    <div className="my-4 text-sm font-normal font-Proxima text-mgrey">
                      <p>Subtotal: $8000.00</p>
                      <p>GST “x”%: $30.00</p>
                      <p>Total: $8,030.00</p>
                    </div>
                  </div>
                </div>
                {/* Sign */}
                <div className="flex justify-between items-center mb-8 mt-28">
                  <div className="font-Proxima font-normal text-sm text-mgrey">
                    <div className="border-b border-b-Grey w-36">
                      <p>Yours Faithfully,</p>
                      <p>FBK Group Pte Ltd</p>
                      <p className="p-4"></p>
                    </div>
                    <p>"Sales Manager Name"</p>
                  </div>
                  <div className="font-Proxima font-normal text-sm text-mgrey">
                    <div className="border-b border-b-Grey w-36">
                      <p>Confirmed and Agreed by</p>
                      <p>"Company Name"</p>
                      <p className="p-4"></p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* Terms & Condition */}
            <div
              className="w-full shadow-lg rounded-lg py-8 px-6"
              id="termsCondition"
              ref={termsConditionRef}
            >
              <div>
                <div className="flex justify-between">
                  <LogoBlack />
                  <div className="w-1/3">
                    <div>
                      <p className="font-Montserrat font-semibold text-xl text-mgrey">
                        FBK Group Pte Ltd
                      </p>
                      <p className="font-Proxima font-normal text-sm text-mgrey">
                        (UEN: 201402444D)
                      </p>
                    </div>
                    <div>
                      <div className="flex items-start">
                        <p className="font-Proxima font-bold text-sm text-black">
                          Address:
                        </p>
                        <p className="font-Proxima font-normal text-sm text-mgrey">
                          {" "}
                          3 Ubi Ave 3 #03-04Crocodile House (S) 540887
                        </p>
                      </div>
                      <div className="flex items-center gap-1">
                        <p className="font-Proxima font-semibold text-sm text-black">
                          Contact No:
                        </p>
                        <p className="font-Proxima font-normal text-sm text-mgrey">
                          6443 3824
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <h2 className="text-3xl font-Montserrat text-mgrey font-normal my-4">
                    Terms & Condition
                  </h2>
                  <p className="font-Proxima text-sm font-normal w-full break-all indent-8">
                    Korem ipsum dolor sit amet, consectetur adipiscing elit.
                    Etiam eu turpis molestie, dictum est a, mattis tellus. Sed
                    dignissim, metus nec fringilla accumsan, risus sem
                    sollicitudin lacus, ut interdum tellus elit sed risus.
                    Maecenas eget condimentum velit, sit amet feugiat lectus.
                    Class aptent taciti sociosqu ad litora torquent per conubia
                    nostra, per inceptos himenaeos. Praesent auctor purus luctus
                    enim egestas, ac scelerisque ante pulvinar. Donec ut rhoncus
                    ex. Suspendisse ac rhoncus nisl, eu tempor urna. Curabitur
                    vel bibendum lorem. Morbi convallis convallis diam sit amet
                    lacinia. Aliquam in elementum tellus. <br /> <br />
                    Curabitur tempor quis eros tempus lacinia. Nam bibendum
                    pellentesque quam a convallis. Sed ut vulputate nisi.
                    Integer in felis sed leo vestibulum venenatis. Suspendisse
                    quis arcu sem. Aenean feugiat ex eu vestibulum vestibulum.
                    Morbi a eleifend magna. Nam metus lacus, porttitor eu mauris
                    a, blandit ultrices nibh. Mauris sit amet magna non ligula
                    vestibulum eleifend. Nulla varius volutpat turpis sed
                    lacinia. Nam eget mi in purus lobortis eleifend. Sed nec
                    ante dictum sem condimentum ullamcorper quis venenatis nisi.
                    Proin vitae facilisis nisi, ac posuere leo. <br /> <br />
                    Nam pulvinar blandit velit, id condimentum diam faucibus at.
                    Aliquam lacus nisi, sollicitudin at nisi nec, fermentum
                    congue felis. Quisque mauris dolor, fringilla sed tincidunt
                    ac, finibus non odio. Sed vitae mauris nec ante pretium
                    finibus. Donec nisl neque, pharetra ac elit eu, faucibus
                    aliquam ligula. Nullam dictum, tellus tincidunt tempor
                    laoreet, nibh elit sollicitudin felis, eget feugiat sapien
                    diam nec nisl. Aenean gravida turpis nisi, consequat dictum
                    risus dapibus a. Duis felis ante, varius in neque eu, tempor
                    suscipit sem. Maecenas ullamcorper gravida sem sit amet
                    cursus. Etiam pulvinar purus vitae justo pharetra consequat.
                    Mauris id mi ut arcu feugiat maximus. Mauris consequat
                    tellus id tempus aliquet.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* submit */}
          {type === "History" ? (
            " "
          ) : (
            <div className="flex justify-end gap-2">
              <DefaultPrimaryButton value="back" onClick={onClose} />
              <DefaultButton
                value="create"
                onClick={() => {
                  setShowConfirmationModal(true);
                }}
              />
            </div>
          )}
        </div>
      </div>

      {/* Confirmation Modal */}
      {showConfirmationModal && (
        <ConfirmationModel
          confirmText="Create"
          isLoading={isLoading}
          onClose={() => setShowConfirmationModal(false)}
          onConfirm={() => setShowDownloadModal(true)}
        />
      )}
      {showDownloadModal && (
        <div className="model" onClick={onClose}>
          <div
            className={`bg-white flex flex-col items-center justify-center drop-shadow-lg rounded-lg w-full max-w-md min-h-40 py-8 px-6 mx-auto relative `}
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <h2
              className={`text-[30px] font-Montserrat mb-3 text-center font-normal`}
            >
              Do you need to download the contract?
            </h2>
            <div className="flex justify-end gap-3 pt-3">
              <button
                onClick={handleDownloadPDF}
                type="button"
                className="text-themeBtn flex items-center uppercase font-Proxima tex-[15px]  justify-center px-6 py-1.5 rounded border border-themeBtn"
              >
                <span>Download</span>
              </button>
              <button
                type="submit"
                className={`flex items-center justify-center px-6 py-1.5 rounded font-Proxima tex-[15px] uppercase ${
                  isLoading
                    ? "bg-disableThemeBtn "
                    : "border-2 border-themeBtn  rounded text-white bg-themeBtn"
                }`}
                disabled={isLoading}
                onClick={onClose}
              >
                {isLoading ? (
                  <ButtonLoader removeTheme={true} />
                ) : (
                  <span>No</span>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Contract;
